import { ISubInfo } from "../views/SubscribeStep2";

export const MIN_LENGTH_SEARCH: number = 3;
export const subscriptionAreas: string[] = [
    "Bilancio, Contabilità e Tributi",
    "Amministrazione",
    "Personale e Organizzazione",
    "Polizia e Attività Economiche",
    "Ufficio Tecnico",
    "Servizi Demografici",
    "Appalti e Contratti",
];
export const subscriptionPeriods: string[] = ["1 anno", "3 anni"];

export const accordionSections = [
    { title: "Benvenuto", text: "Biblioteca Digitale offre oltre 100.000 pagine sempre disponibili su PC, Tablet e Smartphone", image: `${process.env.PUBLIC_URL}/assets/images/digital-book.svg` },
    { title: "Visualizzatore", text: "Visualizzatore che replica fedelmente il volume cartaceo, con indice navigabile e motore di ricerca per parole e concetti all’interno del testo.", image: `${process.env.PUBLIC_URL}/assets/images/visualizzatore.png` },
    { title: "AI generativa", text: "Sistema AI progettato per interrogare i contenuti del volume in modo facile e intuitivo utilizzando il linguaggio naturale.", image: `${process.env.PUBLIC_URL}/assets/images/ai.png` },
    { title: "iLibro", text: "Versione iLIBRO con collegamento ipertestuale ad una banca dati costantemente aggiornata, per visualizzare immediatamente la normativa, prassi e giurisprudenza citate nel volume.", image: `${process.env.PUBLIC_URL}/assets/images/ilibro.png` },
    { title: "Contenuti aggiuntivi", text: "Accesso a tutti i contenuti aggiuntivi collegati ai volumi: schemi di atti, modulistica, flow-chart, video, ecc.", image: `${process.env.PUBLIC_URL}/assets/images/contenuti.png` },
    { title: "Ricerca", text: "Motore di ricerca generale per parole e concetti, che consente di trovare rapidamente i contenuti di interesse all’interno di tutti i volumi della Biblioteca.", image: `${process.env.PUBLIC_URL}/assets/images/ricerca.png` },
]

export const TIME_SEARCH: number = 500;
export const PUBLIC_URL: string = process.env.PUBLIC_URL;

// Costanti Redazionale
export const expressURL: string =
    process.env.NODE_ENV === "development" ? "http://localhost:6565" :  PUBLIC_URL + "/core";

// Costanti Approfondimenti
export const approURL: string = "https://approfondimenti.maggiolicloud.it/auth/api/v2";
export const approUploadsURL: string = "https://approfondimenti.maggiolicloud.it/uploads/";
export const approUser: string = process.env.REACT_APP_APPRO_USER;
export const approPassword: string = process.env.REACT_APP_APPRO_PASS;

export const mailTextContact: string =
    "<h1>Grazie per averci contattato!</h1>" +
    "Provvederemo a rispondere alla tua richiesta il prima possibile.<br/><br/>" +
    "In caso di necessità non esitare a contattare il nostro servizio clienti: <br/> Tel. 0541 628200 <br/>" +
    "(Da lunedì a venerdì dalle ore: 8.30 alle 17.30)";
export const mailTextSub: string =
    "<h1>Grazie per la tua richiesta!</h1>" +
    "Sarai contattato quanto prima da un nostro commerciale per una proposta di preventivo.<br/><br/>" +
    "In caso di necessità non esitare a contattare il nostro servizio clienti: <br/> Tel. 0541 628200 <br/>" +
    "(Da lunedì a venerdì dalle ore: 8.30 alle 17.30)";

export const thankYouTextSub: string = "Grazie per la tua richiesta!<br/>A breve sarei contattato per una proposta commerciale!";
export const thankYouTextContact: string = "Grazie per la tua richiesta, ti contatteremo a breve!";

export function mailText(mailType: string) {
    switch (mailType) {
        case "sales":
            return mailTextSub;
        case "contact":
            return mailTextContact;
        default:
            return "";
    }
}

export function tyText(mailType: string) {
    switch (mailType) {
        case "sales":
            return thankYouTextSub;
        case "contact":
            return thankYouTextContact;
        default:
            return "";
    }
}

// crea un cookie
export const setCookie = (name: string, value: string, seconds: number) => {
    const date = new Date();
    date.setTime(date.getTime() + seconds * 1000);
    const expires = "; expires=" + date.toUTCString();
    document.cookie = name + "=" + (value || "") + expires + "; Secure; SameSite=Lax; path=/";
};

// se c'è, recupera un cookie. altrimenti ritorna null
export const getCookie = (name: string) => {
    const nameEQ = name + "=";
    const ca = document.cookie.split(";");
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === " ") {
            c = c.substring(1, c.length);
        }
        if (c.indexOf(nameEQ) === 0) {
            return c.substring(nameEQ.length, c.length);
        }
    }
    return null;
};

export const clientID: string = "bibliotecadigitale";
export const clientSecret: string = "dS68nUkKpWUqoGpihVuCUdd7brJV8jxB";

// payload di keycloak
export const keycloakPayload = {
    "realm": "maggioli",
    "auth-server-url": "https://sso.maggioli.com/",
    "ssl-required": "external",
    "resource": clientID,
    "credentials": {
        "secret": clientSecret,
    },
    "confidential-port": 0,
};

export const privacyURL: string = "https://privacy.maggiolicloud.it";

// url di redirect in cui si torna una volta loggati su keycloak
export const keycloakRedirectUrl: string =
    process.env.NODE_ENV === "development" ? "http://localhost:3000/" : PUBLIC_URL;

export const oneDayInSeconds: number = 24 * 60 * 60;

export const oneMonthInSeconds: number =  60 * 60 * 24 * 31;

export const footerMessageSubMail = (subInfo: ISubInfo | null): string => {
    if (subInfo === null) {
        return "";
    }
    const areasList: string =
        subInfo.areas[0] === "all"
            ? subscriptionAreas.toString().replace(/, /g, ",").replace(/,/g, ", ")
            : subInfo.areas.toString().replace(/, /g, ",").replace(/,/g, ", ");
    return `La richiesta fa riferimento all'abbonamento riguardante le seguenti informazioni: <br/>
                            Aree tematiche -> ${areasList} <br/>
                            Durata -> ${subInfo.period}.`;
};

interface ISearchbar {
    text: string;
    setText: Function;
    url: string;
    placeholder: string;
    // Identificativo univoco: più campi di ricerca possono coesistere nella stessa pagina
    id?: string;
    // Etichetta accessibile, obbligatoria perché il campo non ne mostra una a video
    label?: string;
    // false per i campi che non sono una ricerca (es. la domanda all'IA)
    isSearch?: boolean;
}

export const searchbar = ({ text, setText, url, placeholder, id = "searchbar", label = "Cerca nella biblioteca", isSearch = true }: ISearchbar) => {
    return <div className="input input--has-icon input--fill overflow-visible" role={isSearch ? "search" : undefined}>
        <label className="sr-only" htmlFor={id}>{label}</label>
        <div className="input__icon-area">
            <i aria-hidden="true" className="icon icon--size-normal input__icon mgg-icons-data-search"></i>
        </div>
        <input className="input__field text-secondary text-secondary--detail" placeholder={placeholder} type={isSearch ? "search" : "text"}
                onChange={(e) => setText(e.target.value)} value={text} key={url} id={id}/>
    </div>
}
